import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONSTANTS } from 'app/app.config';

export type PushPlatform = 'android' | 'ios' | 'web';

export interface PushTokenRow {
  id: number;
  user_id: number;
  token: string;
  platform: PushPlatform;
}

@Injectable({
  providedIn: 'root'
})
export class PushRemote {
  private readonly base = `${APP_CONSTANTS.API_URL}push`;

  constructor(private readonly http: HttpClient) {}

  registerToken(
    token: string,
    platform: PushPlatform,
    deviceInfo: Record<string, unknown> | null = null
  ): Observable<PushTokenRow> {
    return this.http.post<PushTokenRow>(`${this.base}/tokens`, {
      token,
      platform,
      device_info: deviceInfo
    });
  }

  deleteToken(token: string): Observable<{ removed: number }> {
    return this.http.delete<{ removed: number }>(
      `${this.base}/tokens/${encodeURIComponent(token)}`
    );
  }

  trackOpened(campaignId: number): Observable<{ opened: boolean }> {
    return this.http.post<{ opened: boolean }>(
      `${this.base}/deliveries/${campaignId}/opened`,
      {}
    );
  }
}
